import { ErrorBoundary as Boundary } from 'react-error-boundary'
import { ErrorFallback } from 'Features/error/ErrorFallback'
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js'

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const appInsights = useAppInsightsContext()
  const errorHandler = (error: Error) => {
    appInsights.trackException({
      exception: error,
      properties: { errorBoundary: true },
    })
  }
  return (
    <Boundary FallbackComponent={ErrorFallback} onError={errorHandler}>
      {children}
    </Boundary>
  )
}
